import React, { useCallback, useMemo, useState } from "react";
import { FieldProps } from "react-jsonschema-form";
import { ChromePicker } from "react-color";
import { WitLabel } from "./common";

function formatColor(color: { r: number; g: number; b: number; a: number }) {
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
}
const styles = {
  color: {
    width: "36px",
    height: "14px",
    borderRadius: "2px",
  },
  swatch: {
    padding: "5px",
    background: "#fff",
    borderRadius: "1px",
    boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
    display: "inline-block",
    cursor: "pointer",
  },
  popover: {
    position: "absolute",
    zIndex: "2",
  },
  cover: {
    position: "fixed",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px",
  },
};
export function ColorPicker({
  formData,
  onChange,
  rawErrors,
  disabled,
  id,
  schema,
  withInput,
}: FieldProps) {
  const [openPicker, setOpenPicker] = useState<boolean>(withInput ? false : true);
  const handleClick = () => {
    setOpenPicker(prevState => !prevState);
  };
  const handleClose = () => {
    setOpenPicker(false);
  };

  const handleChange = useCallback(
    (color, event) => {
      const transformedColor = `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})`;
      onChange(transformedColor);
    },
    [onChange]
  );

  const color = useMemo(() => {
    if (typeof formData === "string") {
      const values = formData.substring(formData.lastIndexOf("(") + 1, formData.lastIndexOf(")"));

      const arr = values.split(",").map(it => Number(it));

      return { r: arr[0], g: arr[1], b: arr[2], a: arr[3] };
    }
    return { r: 0, g: 0, b: 0, a: 1 };
  }, [formData]);

  return (
    <>
      <WitLabel>{schema?.title}</WitLabel>
      {withInput ? (
        <div className="form-group field field-string">
          <input
            className="form-control cursor-pointer bg-white"
            type="text"
            readOnly
            value={formatColor(color)}
            onClick={handleClick}
          />
        </div>
      ) : null}
      {withInput && openPicker ? (
        <div style={{ ...styles.popover, position: "absolute", zIndex: 2 }}>
          <div
            style={{
              position: "fixed",
              top: "0px",
              right: "0px",
              bottom: "0px",
              left: "0px",
            }}
            onClick={handleClose}
          />
          <ChromePicker color={color} onChange={handleChange} />
        </div>
      ) : null}
      {!withInput ? <ChromePicker color={color} onChange={handleChange} /> : null}
    </>
  );
}
